// nodes/outputNode.js
import { BaseNode } from "../baseNode";
import { nodeConfigs } from "../nodeConfigs";

export const OutputNode = ({ id, data }) => (
  <BaseNode id={id} data={data} config={nodeConfigs.customOutput} />
);
